import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug, deepCopy, sortByAlphabet, sortObjectsByAlphabet } from "../../utils";
import * as deviceService from "../deviceService";
import * as modalDataService from "./modalDataService";
import SelectV2 from "../../view/SelectV2";

function DeviceTypeField({ deviceTypes, selectedId, disabled }) {

    useEffect(() => {
        deviceService
            .loadDeviceTypes()
            .then(devices => {
                if (devices.length > 0 && !selectedId) {
                    const deviceCopy = deepCopy(devices)
                    onChange(deviceCopy.sort((a, b) => sortByAlphabet(a.name, b.name))[0].id);
                }
            });
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (id) => {
        modalDataService.selectDeviceId(id);
    }

    const deviceTypesCopy = sortObjectsByAlphabet(deviceTypes || [], 'name');
    const deviceTypeOptions = deviceTypesCopy.map((device) => ({
        value: device.id,
        label: device.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="deviceType">Device Type <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="deviceType"
                    value={selectedId}
                    onChange={onChange}
                    options={deviceTypeOptions}
                    isDisabled={disabled}
                    placeholder="Select device type"
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("DeviceTypeField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        deviceTypes: addDeviceModal.deviceTypes || [],
        selectedId: addDeviceModal.deviceTypeId
    }
}

export default connect(mapStateToProps)(DeviceTypeField);
